<template>
  <div class="newMemberDetails">
    <iframe :src="memberManageSrc"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberManageSrc: ''
    };
  },
  activated() {
    const { href } = window.location;
    let host = '';
    if (href.includes('duofriend')) {
      host = 'https://member.duofriend.com';
    } else if (href.includes('https://nb')) {
      host = 'https://nbmember.deeptel.com.cn';
    } else {
      host = 'https://member.deeptel.com.cn';
    }
    this.memberManageSrc = `${host}/html/member/pc/views/memberList/index.html#/memberdetail/${window.sessionStorage.memberId}?phone=${window.sessionStorage.memberPhone}&dataSource=0`;
  }
};
</script>

<style lang="less" scoped>
.newMemberDetails{
  margin: 0 0 0 16px;
  width: calc(100vw - 125px);
  display: flex;
  box-orient: vertical;
  box-direction: normal;
  flex-direction: column;
  height: 100%;
  iframe {
    width: 100%;
    border: none;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow-y: auto;
  }
}
</style>
